import { Box } from '@/src/packages/components/ui/Box';
import { Button } from '@/src/packages/components/ui/Button';
import { paths } from '@/src/packages/routes';
import { pathParams } from '@/src/packages/routes/pathParams.enum';
import { getRoute } from '@/src/packages/utils/routes';
import Image from 'next/image';
import Link from 'next/link';
import { IFetchProductVariantSchema } from '@bitmap/contracts';
import { useProductContext } from '@/src/packages/components/pages/Product/ProductContext';
import { BundlePrice } from '@/src/packages/components/pages/Bundle/BundleHeader';
import { Stack } from '@/src/packages/components/ui/Stack';
import { Heading } from '@/src/packages/components/ui/Heading';

export const ProductBundle = ({
  bundle,
}: {
  bundle: IFetchProductVariantSchema['bundles'][0];
}) => {
  return (
    <Box className="bg-background-secondary flex flex-col items-center overflow-hidden md:flex-row">
      <Box className="relative aspect-[4/3] w-full md:aspect-square md:w-[140px]">
        <Image
          src={bundle.images[0].fields.file.url}
          fill
          alt={bundle.name}
          className="object-cover"
          sizes="140px"
        />
      </Box>
      <Box className="flex-1 space-y-3 p-6 text-center md:text-left">
        <Stack className="space-y-2">
          <Heading as="h3" className="text-lg font-medium leading-none">
            {bundle.name}
          </Heading>
          <BundlePrice priceLists={bundle.priceList} />
        </Stack>

        <Button variant="outline" size="sm" asChild>
          <Link
            href={getRoute({
              route: paths.BUNDLES_SINGLE,
              params: { [pathParams.BUNDLE_SINGLE]: bundle.slug },
            })}
            className="block"
          >
            Select options
          </Link>
        </Button>
      </Box>
    </Box>
  );
};

export const ProductBundles = () => {
  const {
    productVariant: { bundles },
  } = useProductContext();

  return (
    <Box>
      <Box className="mb-3" fontWeight="medium" textSize="lg">
        Buy the full set & save
      </Box>
      {bundles.map((bundle) => {
        return <ProductBundle bundle={bundle} key={bundle.id} />;
      })}
    </Box>
  );
};
